import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { fontSize } from "libs/ui/system";

export * from "@/ui/lib/utils/breakpoints/breakpoint.utils";
export * from "@/ui/lib/utils/stories/story.utils";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [ { text: Object.keys(fontSize) } ],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
